import {Box} from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

export default function SessionPerformerCount({scheduledPerformerCount, availablePerformerCount}) {
    return (
        <Box flex={1} display="flex" justifyContent="flex-start">
            <Box display="flex" alignItems="center" gap="0.3rem">
                <PeopleAltIcon sx={{width: '1rem'}}/>
                {scheduledPerformerCount}/{availablePerformerCount}
            </Box>
        </Box>
    );
}
